import Svg, { Path, Rect } from "react-native-svg";

const GenericIcon = ({ size }: DocumentIconSVG) => {
  return (
    <Svg fill="none" height={size} viewBox="0 0 36 36" width={size}>
      <Rect fill="#4CA5A1" height="36" rx="8" width="36" />
      <Path
        d="M22.25 25.5625C22.5312 25.5625 22.8125 25.3164 22.8125 25V14.875H20C19.3672 14.875 18.875 14.3828 18.875 13.75V10.9375H13.25C12.9336 10.9375 12.6875 11.2188 12.6875 11.5V25C12.6875 25.3164 12.9336 25.5625 13.25 25.5625H22.25ZM11 11.5C11 10.2695 11.9844 9.25 13.25 9.25H19.0508C19.6484 9.25 20.2109 9.49609 20.6328 9.91797L23.832 13.1172C24.2539 13.5391 24.5 14.1016 24.5 14.6992V25C24.5 26.2656 23.4805 27.25 22.25 27.25H13.25C11.9844 27.25 11 26.2656 11 25V11.5Z"
        fill="white"
      />
    </Svg>
  );
};

export default GenericIcon;
